import { aiServiceFetch } from "./ai-service-client";
import { HttpError } from "./http-error";

export const INITIAL_PAGE_SIZE = 9;
export const PAGE_SIZE = 3;

export type ProjectsSortBy = "createdAt" | "updatedAt";

export const getProjects = async ({
  type,
  page,
  search,
  sortBy,
  token,
}: {
  type: "my-projects" | "featured-projects";
  page: number;
  search?: string;
  sortBy: ProjectsSortBy;
  token: string;
}) => {
  const basePath =
    type === "my-projects" ? "/api/projects" : "/api/featured-projects";
  const params = new URLSearchParams();

  params.set("page", page.toString());

  if (search) {
    params.set("search", search ?? "");
  }

  params.set("sortBy", sortBy);

  const response = await aiServiceFetch(`${basePath}?${params.toString()}`, {
    method: "GET",
  });

  if (!response.ok) {
    throw await HttpError.fromResponse(response);
  }

  return response.json();
};
